import { Address } from 'api/ApplicationApi';
import { AddressPartsType } from 'enums/AddressPartsType';

import { EMPTY_VALUE_SYMBOL } from './constants';

export interface GeoAttrs {
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  county: string;
}

export const getAddressParts = (
  addressComponents: Array<{ long_name: string; short_name: string; types: string[] }>,
) => {
  return addressComponents.reduce(
    (acc, { types, long_name, short_name }) => {
      if (types.includes(AddressPartsType.State)) {
        acc.state = short_name;
      }

      if (types.includes(AddressPartsType.Locality)) {
        acc.city = long_name;
      }

      if (types.includes(AddressPartsType.PostalCode)) {
        acc.zip = short_name;
      }

      if (types.includes(AddressPartsType.County)) {
        acc.county = short_name;
      }

      return acc;
    },
    { state: '', city: '', zip: '' } as GeoAttrs,
  );
};

export const createAddressStringFromObject = (address: Address | null | undefined): string => {
  if (!address) {
    return EMPTY_VALUE_SYMBOL;
  }

  const fullAddress = `${address.street_number || ''} ${address.street_name || ''} ${address.unit_number || ''}`;

  return fullAddress.trim().length ? fullAddress.trim() : EMPTY_VALUE_SYMBOL;
};
